export const GET_USERLIST = "GET_USERLIST";
export const GET_MAINLANGUAGELIST = "GET_MAINLANGUAGELIST";
export const GET_SPOKENLANGUAGELIST = "GET_SPOKENLANGUAGELIST";
export const GET_PERMISSIONLIST = "GET_PERMISSIONLIST";
export const CREATE_USER = "CREATE_USER";
export const DELETE_USER = "DELETE_USER";
export const EDIT_USER = "EDIT_USER";
